import React from 'react'
import cx from 'classnames'
import { useCallback } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './Chip.scss'


export type ChipProps = {
  // children: never // don't use children
  className?: string
  label: ReactIntlMessage | string
  checked?: boolean
  dataTestId?: string
  onClick?: (checked?: boolean) => void
}

const Chip: React.FunctionComponent<ChipProps> = (props) => {
  const { className, label, checked, dataTestId, onClick } = props

  const rootClassName = cx(className, s.chip, {
    [s.checked]: checked,
  })

  const handleClick = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick(!checked)
    }
  }, [ checked, onClick ])

  return (
    <Box pv={8} ph={16} noWrapper>
      <button
        className={rootClassName}
        type="button"
        role="checkbox"
        aria-checked={checked}
        data-testid={dataTestId}
        onClick={handleClick}
      >
        <Text size="16-24" message={label} ellipsis />
      </button>
    </Box>
  )
}


export default Chip
